import React, { useState, useEffect } from "react";
import { getStorage, setStorage } from "./service/common/storage";
import { defaultContext, Context } from "./service/models/Context";

const getUserContext = (): Context => {
  const stored = getStorage();
  return stored ? stored : defaultContext;
};

export const PreferencesContext = React.createContext<{
  userContext: Context;
  updateUserContext: (ctx: Context | ((prev: Context) => Context)) => void;
}>({
  userContext: defaultContext,
  updateUserContext: () => {},
});

export const PreferencesProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [userContext, setUserContext] = useState<Context>(getUserContext());

  const updateUserContext = (ctx: Context | ((prev: Context) => Context)) => {
    setUserContext((prev) =>
      typeof ctx === "function"
        ? (ctx as (prev: Context) => Context)(prev)
        : ctx
    );
    setStorage(
      typeof ctx === "function"
        ? (ctx as (prev: Context) => Context)(userContext)
        : ctx
    );
  };

  return (
    <PreferencesContext.Provider value={{ userContext, updateUserContext }}>
      {children}
    </PreferencesContext.Provider>
  );
};

// import React from 'react';
// import { getStorage } from './service/common/storage';
// import { Context } from "./service/models/Context";

// function getUserContext()
// {
//   return getStorage();
// }

// const defaultPreferenceState = {
//   userContext: getUserContext(),
//   updateUserContext: (ctx: Context) =>  {},
// };

// export const PreferencesContext = React.createContext(defaultPreferenceState);
